import { api } from "api/api";

const BASE_URL = "/customer-service/rest/web/request";

export const settingAPI = api.injectEndpoints({
  endpoints: (builder) => ({
    changeLanguage: builder.mutation<any, string>({
      query: (lang) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "changeLanguage",
        data: {
          language: lang,
        },
      }),
    }),
    getClientConfig: builder.query<any, void>({
      query: () => ({
        url: BASE_URL,
        method: "POST",
        functionName: "getClientConfig",
      }),
    }),
  }),
});
export const { useChangeLanguageMutation, useGetClientConfigQuery } =
  settingAPI;
